// extracted by mini-css-extract-plugin
export default {"container":"MycawInitialTypeformLink_container__Plpzz"};